import { useEffect, useState } from 'react';
import { type JsonRpcProvider } from '@ethersproject/providers';
import {
    getTokenContract,
    getTokenV2Contract,
    getAuctionContract,
    getAuctionV2Contract,
    getMarketSettingsContract,
    getMarketSettingsV2Contract,
    getRoyaltyEngineContract,
} from 'dibs-crypto-utils/exports/getContract.ts';
import { getChainIdFromEnv } from 'dibs-crypto-utils/exports/supportedChains.ts';
// import {
//     type FirstDibsAuction,
//     type FirstDibsToken,
//     type FirstDibsTokenV2,
//     type FirstDibsMarketSettings,
//     type FirstDibsMarketSettingsV2,
//     type FirstDibsAuctionV2,
//     type RoyaltyEngineV1,
// } from '1stdibs-contracts/typechain';
import { useWeb3Connection } from 'dibs-crypto-utils/exports/useWeb3Connection.ts';

// 1stdibs-contracts not compatible with verbatimModuleSyntax
type FirstDibsAuction = $TSFixMe;
type FirstDibsToken = $TSFixMe;
type FirstDibsTokenV2 = $TSFixMe;
type FirstDibsMarketSettings = $TSFixMe;
type FirstDibsMarketSettingsV2 = $TSFixMe;
type FirstDibsAuctionV2 = $TSFixMe;
type RoyaltyEngineV1 = $TSFixMe;

type Contracts = {
    auction: FirstDibsAuction;
    token: FirstDibsToken;
    tokenV2: FirstDibsTokenV2;
    marketSettings: FirstDibsMarketSettings;
    marketSettingsV2: FirstDibsMarketSettingsV2 | null;
    auctionV2: FirstDibsAuctionV2 | null;
    royaltyEngine: RoyaltyEngineV1 | null;
};

export function useDibsContracts(
    library?: JsonRpcProvider
): [contracts: Contracts | null, error: boolean | null] {
    const [contracts, setContracts] = useState<Contracts | null>(null);
    const [error, setError] = useState(false);
    const { alchemyProvider } = useWeb3Connection();
    const chainId = getChainIdFromEnv();

    useEffect((): void => {
        (async function fetchContracts() {
            const provider = library || alchemyProvider;
            if (provider && chainId) {
                try {
                    const [
                        tokenContract,
                        tokenV2Contract,
                        auctionContract,
                        marketSettingsContract,
                        auctionV2Contract,
                        marketSettingsV2Contract,
                        royaltyEngineContract,
                    ] = await Promise.all([
                        getTokenContract(provider, chainId),
                        getTokenV2Contract(provider, chainId),
                        getAuctionContract(provider, chainId),
                        getMarketSettingsContract(provider, chainId),
                        getAuctionV2Contract(provider, chainId),
                        getMarketSettingsV2Contract(provider, chainId),
                        getRoyaltyEngineContract(provider, chainId),
                    ]);

                    if (
                        tokenContract &&
                        auctionContract &&
                        marketSettingsContract &&
                        tokenV2Contract
                    ) {
                        setContracts({
                            token: tokenContract,
                            tokenV2: tokenV2Contract,
                            auction: auctionContract,
                            marketSettings: marketSettingsContract,
                            marketSettingsV2: marketSettingsV2Contract,
                            auctionV2: auctionV2Contract,
                            royaltyEngine: royaltyEngineContract,
                        });
                    } else {
                        setError(true);
                    }
                } catch {
                    setError(true);
                }
            }
        })();
    }, [alchemyProvider, chainId, library]);

    return [contracts, error];
}
